import { v4 as uuidv4 } from 'uuid';

export function VisibilityLayout(props = {}, childrenComponents = []) {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		props: Object.assign(
			{
				visible: true,
			},
			props,
		),
		childrenComponents,
	};
}
